import React from "react"
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import Column from "@amzn/meridian/column";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const StaticMetricView = (props) => {
    const {isMobile} = useDeviceLayout()
    const textFont = isMobile ? "b100" : "b300"
    return (
        <Column spacing={"small"}>
            <Text type="d50">
                {props.data.value}
            </Text>
            <Text type={textFont} color={"secondary"}>
                <FormattedMessage id={props.data.title} defaultMessage={props.data.message} />
            </Text>
        </Column>
    )
}

export default StaticMetricView


// WEBPACK FOOTER //
// ./src/components/pickStatus/StaticMetricView.js